import { render } from "./Evaluation.vue?vue&type=template&id=3f461bda&scoped=true"
import script from "./Evaluation.vue?vue&type=script&lang=js"
export * from "./Evaluation.vue?vue&type=script&lang=js"

import "./Evaluation.vue?vue&type=style&index=0&id=3f461bda&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f461bda"]])

export default __exports__